const nl = {
  nav: {
    home: 'Startpagina',
    products: 'Onze Producten',
    about: 'Over Ons',
    contact: 'Contact',
  },
  home: {
    hero: {
      eyebrow: 'Finisher Kits & Technische Textiel',
      title1: 'UITRUSTING VOOR UW',
      title2: 'SPORTEVENEMENTEN',
      subtitle: 'Gepersonaliseerde medailles, textiel en accessoires voor sportevementenorganisatoren in België en Frankrijk.',
      cta1: 'Ontdek de pakketten',
      cta2: 'Vraag een offerte aan',
    },
    problems: {
      title: 'De uitdaging van de organisator',
      pain_title: 'Terugkerende problemen',
      solution_title: 'De Ultra Sport aanpak',
      pains: [
        'Levertijden niet nagekomen',
        'Teleurstellende kwaliteit bij ontvangst',
        'Niet-gespecialiseerde sportcontact',
        'Geen persoonlijke opvolging',
        'Last-minute verrassingen',
        'Complexe multi-leveranciers logistiek',
      ],
      solutions: [
        'Omgekeerde planning gegarandeerd',
        'Veld-getest en gevalideerde producten',
        'Expert in sportevenementen',
        'Één aanspreekpunt van offerte tot levering',
        'BAT gevalideerd voor elke productie',
        'Levering altijd inbegrepen',
      ],
    },
    packs: {
      title: 'Onze Complete Pakketten',
      subtitle: 'Van essentieel tot premium, een oplossing voor elk evenement',
      cta: 'Zie volledige details',
      see_all: 'Zie alle producten',
      essential: {
        name: 'Finisher Essentieel Pakket',
        participants: '200 – 800 deelnemers',
        tagline: 'Eenvoudig, effectief, gecontroleerd budget',
        items: [
          'Trail beker',
          'Lifestyle of sport pet',
          'Hardloop- en fiets sokken',
          '500 ml fles',
          '... (al uw projecten zijn haalbaar)',
        ],
      },
      performance: {
        name: 'Performance Pakket',
        participants: '800 – 1500+ deelnemers',
        badge: 'AANBEVOLEN',
        tagline: 'Ideaal voor Trail en Triatlon',
        loyalty: '2e bestelling -20%',
        items: [
          'Finisher medaille 6cm en 2.5 cm sublimatie lint',
          'Lifestyle en Sport pet',
          'Trail fles',
          'Rugzak',
          '... Al uw projecten zijn haalbaar',
        ],
      },
      premium: {
        name: 'Premium Pakket',
        participants: '1500 – 2000+ deelnemers',
        tagline: 'Sterk imago en blijvende herinnering',
        loyalty: '2e -20%, 3e -30%',
        items: [
          'Trail beker',
          'Ice Silk Buff premium',
          'Geborduurde pet',
          'Trail fles',
          'Rugzak',
          '... Al uw projecten zijn haalbaar',
        ],
      },
    },
    vip: {
      title: 'De VIP-Ervaring voor uw Deelnemers',
      formula: 'UltraTiming + Ultra Sport = VIP Distributie Setup',
      description: 'Combineer de expertchronometrie van UltraTiming met de premium kits van Ultra Sport voor een onvergetelijke finisherervaring.',
      timing_label: 'Expert chronometrie & realtime resultaten',
      goodies_label: 'Premium finisher kits & georganiseerde distributie',
      result_label: 'Volledig VIP evenement',
      discover: 'Ontdek UltraTiming.live',
    },
    clients: {
      title: 'Zij Vertrouwen Ons',
      subtitle: 'Meer dan 18 sportevenementen hebben ons hun finisher kits toevertrouwd',
    },
    promo: {
      badge: 'SPECIALE AANBIEDING',
      text: 'Finisher Pack T-shirt + Medaille vanaf',
      price: '€6,50 excl. BTW',
      cta: 'Vraag een offerte aan',
    },
    why_choose: {
      eyebrow: 'Waarom ons kiezen?',
      title: '6 Redenen om Ultra Sport te kiezen',
    },
    stats: {
      events: { value: 150, suffix: '+', label: 'Evenementen uitgerust' },
      delivery: { value: 100, suffix: '%', label: 'Levering op tijd' },
      participants: { value: 50000, suffix: '+', label: 'Tevreden deelnemers' },
      expertise: { value: 2015, suffix: '', label: "Sinds" },
    },
    reasons: {
      planning: { title: 'Gegarandeerde Planning', desc: 'Levering verzekerd voor uw evenement, geen verrassingen' },
      quality: { title: 'Geteste Kwaliteit', desc: 'Producten gevalideerd in het veld door sporters' },
      expert: { title: 'Sport Expert', desc: 'Specialist in sportevenementen sinds 2015' },
      contact: { title: 'Enkel Aanspreekpunt', desc: 'Één contact van offerte tot levering' },
      bat: { title: 'BAT Gevalideerd', desc: 'Drukproef goedgekeurd voor elke productie' },
      delivery: { title: 'Levering Inbegrepen', desc: 'Verzending altijd inbegrepen, geen verborgen kosten' },
    },
    contact: {
      title: 'Vraag een Offerte Aan',
      subtitle: 'Vertel ons over uw evenement — gegarandeerd antwoord binnen 24u',
      nom: 'Achternaam',
      prenom: 'Voornaam',
      email: 'E-mail',
      event_name: 'Naam evenement',
      participants: 'Aantal deelnemers',
      pack_choice: 'Keuze pakket',
      event_date: 'Datum evenement',
      message: 'Bericht',
      pack_options: ['Finisher Essentieel Pakket', 'Performance Pakket', 'Premium Pakket', 'Speciale Aanbieding T-shirt + Medaille', 'Aangepaste offerte'],
      submit: 'Aanvraag verzenden',
      sending: 'Verzenden...',
      success: 'Uw aanvraag is verzonden! We nemen binnen 24u contact op.',
      error: 'Er is een fout opgetreden. Probeer opnieuw.',
    },
  },
  products: {
    title: 'Onze Producten',
    subtitle: 'Volledige catalogus van finisher kits en technische textiel',
    packs_title: 'Onze Complete Pakketten',
    packs_subtitle: 'Kant-en-klare oplossingen voor elk evenement',
    catalog_title: 'Onze Realisaties',
    catalog_subtitle: 'Ontdek onze gepersonaliseerde creaties',
    planning_title: 'Omgekeerde Planning',
    planning_subtitle: 'Bereken uw termijnen — veilige levering gegarandeerd',
    quality_title: 'Kwaliteit Gegarandeerd',
    quality_badge: 'Geen product komt in onze catalogus zonder intern getest en gevalideerd te zijn door het UltraTiming team',
    request_quote: 'Vraag een offerte aan',
    products_included: 'Producten inbegrepen',
    services_included: 'Services inbegrepen',
    ideal_for: 'Ideaal voor',
    na: 'N/B',
    filters: {
      all: 'Alle',
      textile: 'Textiel',
      medals: 'Medailles',
      hydration: 'Hydratie',
      accessories: 'Accessoires',
      bags: 'Tassen',
      packaging: 'Verpakking',
    },
    packs: {
      essential: {
        name: 'Finisher Essentieel Pakket',
        badge: 'ESSENTIEEL',
        participants: '200 – 800 deelnemers',
        tagline: 'Eenvoudig, effectief, gecontroleerd budget',
        services: [
          'Grafisch ontwerp inbegrepen (1 voorstel + bewerkingen)',
          'Verplichte BAT voor productie',
          'Productiestart na validatie',
          'Levering altijd inbegrepen',
          'Gegarandeerde realistische deadline',
        ],
        products: [
          'Trail beker',
          'Lifestyle of sport pet',
          'Hardloop- en fiets sokken',
          '500 ml fles',
          '... (al uw projecten zijn haalbaar)',
        ],
      },
      performance: {
        name: 'Performance Pakket',
        badge: '★ AANBEVOLEN ★',
        participants: '800 – 1500+ deelnemers',
        tagline: 'Ideaal voor Trail en Triatlon',
        loyalty: '2e bestelling: -20%',
        services: [
          'Grafisch ontwerp inbegrepen (1 voorstel + bewerkingen)',
          'Verplichte BAT validatie',
          'Productiestart',
          'Levering inbegrepen',
          '2e goodies bestelling: -20%',
        ],
        products: [
          'Finisher medaille 6cm en 2.5 cm sublimatie lint',
          'Lifestyle en Sport pet',
          'Trail fles',
          'Rugzak',
          '... Al uw projecten zijn haalbaar',
        ],
      },
      premium: {
        name: 'Premium Pakket',
        badge: 'PREMIUM',
        participants: '1500 – 2000+ deelnemers aanbevolen',
        tagline: 'Sterk imago en blijvende herinnering',
        loyalty: '2e -20% | 3e -30%',
        services: [
          'Grafisch ontwerp inbegrepen (2 voorstellen + bewerkingen)',
          'Verplichte BAT validatie',
          'Productiestart',
          'Levering inbegrepen',
          '2e goodies bestelling: -20%',
          '3e goodies bestelling: -30%',
        ],
        products: [
          'Trail beker',
          'Ice Silk Buff premium',
          'Geborduurde pet',
          'Trail fles',
          'Rugzak',
          '... Al uw projecten zijn haalbaar',
        ],
      },
    },
    quality: {
      medals_title: 'Medailles',
      medals_text: 'Robuuste zinklegering, gecontroleerde afwerkingen, reliëf/emaillering/snijden, nauwkeurige BAT validatie',
      textile_title: 'Textiel',
      textile_text: 'Resistente sublimatie, ademend sportweefsel, geoptimaliseerde unisex maten, zelfde producenten als Compressport',
      accessories_title: 'Accessoires',
      accessories_text: 'Voedselkwaliteit gecertificeerde materialen, bestendig, veldgetest voor trail/running/triatlon',
    },
    planning_note: '10 werkdagen tussen ondertekende offerte en productiestart. Formaat = productiedagen + leveringsdagen.',
    planning_products: {
      tshirt: 'Technisch T-shirt',
      cup: 'Beker / Fles',
      buff: 'Buff / Nekwarmer',
      cap: 'Pet',
      socks: 'Hoge sokken',
      medal: 'Medaille',
      backpack: 'Rugzak',
      packaging: 'Premium verpakking',
    },
    items: {
      tshirt_210: { name: 'Technisch T-shirt 210gr', desc: '100% ademend polyester, 210gr/m², 1-kleur sublimatie, unisex XS tot 3XL', ideal: 'Budget evenementen, grote aantallen', packs: 'Essentieel' },
      tshirt_110: { name: 'Technisch T-shirt 110gr Gestructureerd', desc: 'Ultra-licht gestructureerd polyester, volledige sublimatie, mesh ademend, XS tot 3XL', ideal: 'Trail, triatlon, langdurig lopen', packs: 'Performance & Premium' },
      medal_6cm: { name: 'Finisher Medaille 6cm', desc: 'Robuuste zinklegering, gegraveerd reliëf, 2cm aangepast gesublimeerd lint, verplichte BAT', ideal: 'Evenementen 800–1500+ deelnemers', packs: 'Performance' },
      medal_7cm: { name: 'Finisher Medaille 7cm Premium', desc: 'Zinklegering, premium afwerkingen, 3cm lint, emaillering en speciaal snijden mogelijk', ideal: 'Prestige evenementen 1500+ deelnemers', packs: 'Premium' },
      medal_custom: { name: 'Maatwerkmedaille', desc: 'Vrije vorm, aangepaste afmetingen, meerdere afwerkingen (goud, zilver, brons, geëmailleerd)', ideal: 'Evenementen met sterke identiteit', packs: 'Op offerte' },
      cup_silicon: { name: 'Opvouwbare Siliconen Beker', desc: 'Voedselkwaliteit BPA-vrij siliconen, 150ml of 200ml, 1–3 kleur logo, clip bevestiging', ideal: 'Trail, running, milieuvriendelijke evenementen', packs: 'Alle pakketten' },
      cup_pp: { name: 'Herbruikbare PP Beker', desc: 'BPA-vrij polypropyleen, 25cl of 33cl, 1–3 kleur logo, stevig en stapelbaar', ideal: 'Startbewijsdistributie, economisch', packs: 'Alle pakketten' },
      flask_150: { name: 'Zachte Trail Fles 150ml', desc: 'Voedselkwaliteit TPU, lekvrije bite valve dop, 1–3 kleur logo', ideal: 'Trail, running, compatibel met hydratatieriem', packs: 'Alle pakketten' },
      flask_250: { name: 'Zachte Trail Fles 250ml', desc: 'Voedselkwaliteit TPU, bite valve dop, 1–3 kleur logo', ideal: 'Lange afstand trail, triatlon', packs: 'Alle pakketten' },
      buff_poly: { name: 'Polyester Nekwarmer / Buff', desc: '100% licht polyester, volledige sublimatie print, universele maat, 12 manieren te dragen', ideal: 'Alle seizoenen evenementen', packs: 'Essentieel' },
      buff_icesilk: { name: 'Ice Silk Nekwarmer / Buff', desc: 'Koel aanvoelend materiaal, verkoelend effect, HD volledige sublimatie print', ideal: 'Zomer, warme trail, triatlon', packs: 'Performance & Premium' },
      cap_5p_1c: { name: '5-Panelen Pet — 1 Kleur', desc: 'Ademend polyester/katoen, gebogen klep, velcro of snapback, 1-kleur zeefdruk', ideal: 'Budget evenementen', packs: 'Essentieel' },
      cap_56p_2c: { name: '5/6-Panelen Pet — 2 Kleuren', desc: 'Ademend polyester, anti-UV mogelijk, velcro/snapback/elastiek, 2-kleur zeefdruk', ideal: 'Trail, triatlon', packs: 'Performance' },
      cap_emb: { name: 'Geborduurd Pet 2 Kleuren', desc: 'Premium polyester of kamgaren katoen, hoge kwaliteit 2-kleur borduurwerk, premium afwerking', ideal: 'Premium merkimago', packs: 'Premium' },
      socks: { name: 'Hoge Sportsokken', desc: 'Polyester/elastaan, hiel- en teenversteviging, 1–2 kleur jacquard logo, maten 35–46', ideal: 'Trail, running, triatlon, lange afstand', packs: 'Alle pakketten' },
      backpack: { name: 'Lichte Trail Rugzak', desc: 'Licht nylon 5–10L, 2-kleur logo, gevoerde schouderbanden, hydratatiepak compatibel', ideal: 'Lange afstand trail, gedenkwaardig cadeau', packs: 'Performance & Premium' },
      totebag: { name: 'Non-Woven Draagtas', desc: 'Recyclebaar polypropyleen 38x42cm, 1-kleur logo', ideal: 'Startbewijsdistributie, goodies bag', packs: 'Op offerte' },
      sachet_zip: { name: 'Aangepaste Transparante Ritszak', desc: 'Helder plastic met rits, logo + evenementnaam, maten S/M/L', ideal: 'Premium presentatie van elke kit', packs: 'Premium' },
      box_premium: { name: 'Premium Kartonnen Doos', desc: 'Stevig karton, matte of glanzende afwerking, aangepaste full-print buitenkant', ideal: 'High-end deelnemerservaring', packs: 'Premium — op offerte' },
    },
  },
  about: {
    title: 'Over Ons',
    subtitle: 'De finisher kit expert voor sportevenementen',
    story_title: 'Ons Verhaal',
    story_text: 'Ultra Sport ontstond uit een passie voor sportevenementen en een frustratie die door vele organisatoren wordt gedeeld: het vinden van een betrouwbare, gespecialiseerde leverancier die de unieke beperkingen van de sportwereld begrijpt. Opgericht door het UltraTiming team, zetten wij onze veldexpertise in dienst van evenementenorganisatoren in België en Frankrijk.',
    values_title: 'Onze Waarden',
    values: [
      { title: 'Betrouwbaarheid', text: 'Onze toezeggingen worden nagekomen. Termijnen, kwaliteit en communicatie: we doen geen compromissen over wat telt op de grote dag.' },
      { title: 'Sport Expertise', text: 'We kennen sportevenementen van binnenuit. Trail, triatlon, running: we leven al jaren in deze wereld.' },
      { title: 'Geteste Kwaliteit', text: 'Elk product wordt veldgetest voordat het in onze catalogus wordt opgenomen. Nul verrassingen op uw evenementdag.' },
      { title: 'Duurzaam Partnerschap', text: 'Langetermijnpartner, loyaliteit beloond. -20% vanaf de 2e bestelling, -30% bij de 3e. We groeien samen.' },
    ],
    partnership_title: 'Ons UltraTiming Partnerschap',
    partnership_text: 'Ultra Sport is de goodies en textieltak van UltraTiming, Europees specialist in sportevenementenchronometrie. Door deze unieke synergie begrijpen we de behoeften van organisatoren perfect.',
    partnership_cta: 'Ontdek UltraTiming.live',
    clients_title: 'Zij Vertrouwen Ons',
    clients_subtitle: 'Evenementen van alle groottes vertrouwen ons voor hun finisher kits',
    cta_title: 'Klaar om uw evenement uit te rusten?',
    cta_text: 'Neem contact op voor een gepersonaliseerde offerte. Antwoord gegarandeerd binnen 24u.',
    cta_button: 'Vraag een offerte aan',
  },
  footer: {
    tagline: 'De officiële uitrusting voor uw sportevenementen',
    contact_email: 'info@ultrasport.live',
    ultratiming: 'Bezoek UltraTiming.live',
    copyright: '© 2026 Ultra Sport – Sports Event Goodies. Alle rechten voorbehouden.',
  },
};

export default nl;
